import { render, staticRenderFns } from "./BaitulmalGrid.vue?vue&type=template&id=2d1c3d36"
import script from "./BaitulmalGrid.vue?vue&type=script&lang=js"
export * from "./BaitulmalGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports